import React from "react";
import {
  UserCheck,
  MapPin,
  Bell,
  HeartPulse,
  ShieldCheck,
} from "lucide-react";
import PageWrapper from "../components/PageWrapper";
import PageHero from "../components/PageHero";
import BusImage from "../components/BusImage";
import FeatureCard from "../components/FeatureCard";

const features = [
  {
    icon: UserCheck,
    title: "Verified Drivers & Attendants",
    description:
      "All drivers and attendants are background-verified, trained in child safety, and follow strict conduct standards.",
  },
  {
    icon: MapPin,
    title: "Live GPS Monitoring",
    description:
      "Real-time GPS tracking ensures monitored routes, controlled speed, and geofenced safety zones.",
  },
  {
    icon: Bell,
    title: "Boarding & Drop Alerts",
    description:
      "Instant notifications when your child boards and reaches their drop point for complete visibility and peace of mind.",
  },
  {
    icon: HeartPulse,
    title: "Emergency Response Support",
    description:
      "24/7 support and escalation protocols ensure quick action in any emergency, anytime, anywhere.",
  },
];

const Safety = () => {
  return (
    <PageWrapper testId="safety-page">
      <PageHero
        eyebrow={
          <>
            <ShieldCheck size={16} />
            Safety First, Always
          </>
        }
        title={
          <>
            <span>Student Safety</span>
            <br />
            <span>at </span>
            <span className="brand-blue">Every Step</span>
            <span className="text-amber-500">.</span>
          </>
        }
        description="At MDST Travels, child safety is our highest priority. From trained staff and monitored operations to disciplined routing and transparent communication, we ensure peace of mind for parents and a secure journey for every child."
        rightContent={<BusImage variant="safety" />}
      />

      <section
        className="max-w-[1280px] mx-auto px-5 lg:px-10 -mt-2 mb-14"
        data-testid="safety-features"
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <FeatureCard
              key={f.title}
              icon={f.icon}
              title={f.title}
              description={f.description}
              variant="check"
              index={i}
              testId={`safety-feature-${i}`}
            />
          ))}
        </div>
      </section>
    </PageWrapper>
  );
};

export default Safety;
